import angular from 'angular';
import modalConfirmationCart from '../../catalog/modal-confirmation/modal-confirmation.view.html';
import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
import modalSelectModalidadPago from '../../shared/components/modal-select-modalidad-pago/modal-select-modalidad-pago.view.html';

let inject = [
  '$scope',
  '$state',
  '$rootScope',
  'BySearchService',
  '$uibModal',
  'CartService',
  'Pagination',
  'SessionService',
  '$mdToast'  ,
  'SharedService'
];

class BySearchController {
    constructor($scope, $state, $rootScope, BySearchService, $uibModal, CartService, Pagination, SessionService, $mdToast,SharedService) {
    this.$scope = $scope;
    this.$state = $state;
    this.$rootScope = $rootScope;
    this.BySearchService = BySearchService;
    this.$uibModal = $uibModal;
    this.CartService = CartService;
    this.paginator = Pagination;
    this.SessionService = SessionService;
    this.$mdToast = $mdToast;
    //this.globals = this.shCtrl.globals;

    this.products = [];
    this.fastSearch = true;
    this.searchingProducts = false;
    this.itemsPerPage = 12;
    this.currentPage = 1;
    this.pagination = {};
    this.sortType = 'name'
    this.sortReverse = false;
    this.SharedService = SharedService;
    this.searchTextOld = '';
  }

  doFastSearch(searchText) {
    this.loaded = false;
    if (angular.isDefined(searchText) && !angular.equals('')) {

      if(!angular.equals(this.searchTextOld,searchText) && this.searchTextOld != ""){
        this.itemsPerPage = 12;
        this.currentPage = 1;
      }

      this.searchTextOld = searchText;

      let data = {
        pageSize: this.itemsPerPage,
        searchText: decodeURIComponent(searchText),
        internSearchText: this.searchText,
        userId: this.shCtrl.globals.currentUser.userId,
        filters: {
          pageNumber: this.currentPage,
      }
    };
      this.searchingProducts = true;

      this.BySearchService.getProducts(data).then(response => {
        this.products = response;

        this.searchingProducts = false;
        this.pagination = this.paginator.getNew(this.itemsPerPage);
        this.pagination.numPages = Math.ceil(this.products.length/this.pagination.perPage);
      }).catch(error => {
        console.log(error)
      })
    }
  }

  setPagination(itemsPerPage) {
    this.itemsPerPage = itemsPerPage;
    this.pagination = this.paginator.getNew(this.itemsPerPage);
    this.pagination.numPages = Math.ceil(this.products.length/this.pagination.perPage);
  }

  decreaseProductQuantity (product) {
    if (product.quantityCart > 1){
      product.quantityCart-= (product.factor_pedido>0)?product.factor_pedido:1;
    }
    if(product.cantidad_minima>0 && product.quantityCart < product.cantidad_minima){
        if(product.factor_pedido > product.cantidad_minima){
            product.quantityCart=product.factor_pedido;
        }else{
            product.quantityCart=product.cantidad_minima;
        }
    }else if(product.cantidad_minima<0 && product.quantityCart < product.cantidad_minima){
        product.quantityCart=1;
    }
  }
  increaseProductQuantity (product) {
    product.quantityCart = parseFloat(product.quantityCart) + ((parseFloat(product.factor_pedido)>0)? parseFloat(product.factor_pedido):1);
  }

  addItemToCart(product) {
    if (product.id) {
      let userId = '',
        cart = null;
      try {
        userId = this.shCtrl.globals.currentUser.userId;
      } catch (e) {};
      try {
        cart = this.shCtrl.cart;
      } catch (e) {};

      let validation = this.SessionService.validateFactorItems(product.quantityCart, product);
      if (validation.error) {
        let options = {
          title: '',
          isHtml: true,
          content: validation.message,
          size: '',
          showBottonCancel: false,
          textActionCancel: '',
          textAction: 'Aceptar'
        };
        this.messageResponse(options);
        return;
      }

      this.CartService.addItemToCart(product, product.quantityCart, null, null, userId, cart).then(response => {
        if (!response.error) {
          // this.$scope.$emit('onUpdateCart');

          // let modalInstance = this.$uibModal.open({
          //   animation: true,
          //   template: modalConfirmationCart,
          //   controller: 'ModalConfirmationController',
          //   controllerAs: 'mdCtrl',
          //   size: 'lg',
          //   resolve: {
          //     product: () => product
          //   }
          // });

          this.dataCart = {};
          this.dataProducs = {};

          if (!response.pesoValidoBodega && response.modalidadParametrizada) {
            this.cambiarSucursalVolumenItemMostrarMedioEnvio(response,product, product.quantityCart);
          } else if (!response.pesoValidoBodega && !response.modalidadParametrizada) {
            this.cambiarSucursalVolumenItems(response, cart, product, product.quantityCart);
          } else if (response.pesoValidoBodega && response.modalidadParametrizada) { // Si el peso de la bodega es valido y la modalidad no esta en el carrito
            this.showModalSelectModalidadPago(response, product, product.quantityCart);
          } else {
            this.modalConfirmation(product, product.quantityCart);
          }


        } else {
        /*  if (response.agotado) {
            product.cantidad = response.itemStock;
            this.CartService.updateItemsNotAvailable(product, product.quantityCart, userId);
          } */


          let options = {
            title: '',
            isHtml: true,
            content: response.message,
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };
          this.messageResponse(options);
        }
      }).catch(reason => {
        let options = {
          title: '',
          isHtml: false,
          content: reason,
          size: '',
          showBottonCancel: false,
          textActionCancel: '',
          textAction: 'Aceptar'
        };
        this.messageResponse(options);
      })
    }
  }

  updateFavoriteProducts(product) {
    product.isSettingAsFavorite = true;
    let userId = '';
    try {
      userId = this.shCtrl.globals.currentUser.userId;
    } catch (e) {}
    if (userId) {
      let data = {
        'productId': product.id,
        'userId': userId,
        'setFavorite': !product.isFavorite
      };

      this.BySearchService.updateFavoriteProducts(data).then(response => {

        if (!response.error) {
          this.BySearchService.getResumeProductsFavorites(this.shCtrl.globals.currentUser.userId).then(favoritesResponse => {
            this.shCtrl.globals.currentUser.favoriteItems = favoritesResponse;
            this.SessionService.put('globals', this.shCtrl.globals);

          });
        }

        product.isFavorite = !product.isFavorite;
        product.isSettingAsFavorite = false;
      }).catch(error => {
        product.isSettingAsFavorite = false;
        let options = {
          title: '',
          isHtml: false,
          content: 'Ha ocurrido un error al actualizar el producto',
          size: '',
          showBottonCancel: false,
          textActionCancel: '',
          textAction: 'Aceptar'
        };
        this.messageResponse(options);
      });
    }
  }

  messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller: 'ModalResponseController',
      controllerAs: 'mdCtrl',
      size: options.size,
      resolve: {
        modalOptions: () => options
      }
    });
    modalInstance.result.then(() => {
      if (callAcept) {
        callback();
      }
    }).catch(reason => {
      if (callCancel) {
        callbackCancel();
      }
    });


  }
    modalConfirmation(products, quantity) {

        this.productAdded = products;
        this.productAdded.image = products.imagesDetail[0].path + products.imagesDetail[0].image;
        this.productAdded.price = products.itemPrice;
        this.productAdded.discount = products.discountValue;
        this.productAdded.ivaValue = products.taxValue;
        this.productAdded.quantity = quantity;
        //this.productAdded.total = (products.itemPrice - products.discountValue + products.taxValue) * quantity;
        this.productAdded.total = (products.itemPrice - products.discountValue + products.taxValue + products.taxImpConsumoValue) * quantity;


        if (__env.adaptative) {
            this.messageMaterial(products.name + ' Ha sido agregado correctamente')
        } else {
            $('#ModalproductDetail').modal('toggle');
        }

        this.$scope.$emit('onUpdateCart', 'modalResponseItems');
    }

    messageMaterial(text) {
        var mdToast = this.$mdToast;
        this.$mdToast.show({
            hideDelay: 7000,
            controller: function () {
                this.closeToast = function () {
                    mdToast.hide();
                }

            },
            controllerAs: 'toast',
            template: '<md-toast>\n' +
                '  <span class="md-toast-text">' + text + '</span>\n' +
                '  <md-button ng-click="toast.closeToast()">\n' +
                '    Cerrar\n' +
                '  </md-button>\n' +
                '</md-toast>'
        });
    }

    showSort(value) {
      this.sort = value;
  }

  showModalSelectModalidadPago(modalidadesPago, product, quantity) {

    let options = {
      userData: this.shCtrl.globals,
      branches: this.shCtrl.globals.currentUser.operatingCenters,
      currentBranch: this.shCtrl.globals.currentClient.operatingCenter,
      cmsMessage: this.shCtrl.globalParams.cmsInfo,
      modalidadesPago: modalidadesPago
    };
    let modalInstance = this.$uibModal.open({
      animation: true,
      static: true,
      template: modalSelectModalidadPago,
      controller: 'ModalSelectModalidadController',
      controllerAs: 'mdCtrl',
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
      resolve: {
        modalOptions: () => options
      }
    });
    modalInstance.result.then(result => {
      this.modalConfirmation(product, quantity);
    }).catch(reason => {

    });
  }

  cambiarSucursalVolumenItems(response, cart, product, quantity) {
    let cartId = cart.cartId
    let responseData = response
    this.CartService.getShippingMode(cartId).then(response => {
      if (response.modalidad) {
        this.setSucursalesPorModalidad(response, cartId, product, quantity);
      } else {
        this.obtenerSucursalSecundaria(cartId, product, quantity);
      }
    });
  }

  setSucursalesPorModalidad(response, cartId, product, quantity) {
    let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
    let idUsuario = this.shCtrl.globals.currentUser.userId;
    let currentClient  = this.SessionService.get('currentClient');
    let idSucursalActual = currentClient.operatingCenter.id;
    let data = {
      'userId': idUsuario,
      'ciudadId': idCiudad
    };
    let tipoModalidad = response.modalidad.tipo_modalidad;
    // Si la modalidad es recoge
    if (tipoModalidad == 0) {
      this.CartService.getSecondaryBranch(data).then(response => {
        let idSucursalSecundaria = response.listaSucursales[0].id;
        if (idSucursalSecundaria != null) {
          if(idSucursalSecundaria != idSucursalActual){
            this.setSucursalSecundariaRecogeEntrega(idSucursalSecundaria, idUsuario, product, quantity);
          }else{
            this.modalConfirmation(product, quantity);
          }
        }
      });
      this.CartService.updateDateCart(cartId).then(response => {
        return response;
      });
      // Si es a domicilio
    } else {
      this.CartService.getSecondaryBranch(data).then(response => {
        let idSucursalSecundaria = response.listaSucursales[0].id;
        let idCiudad = response.listaSucursales[0].ciudad_id;

        if (idCiudad != null && idSucursalSecundaria != null && cartId != null) {
          this.CartService.updatePromiseCart(cartId, idSucursalSecundaria, idCiudad).then(response => {
            let aplicaServicioDescargue = response.aplicaServicioDescargue;
            if (idSucursalSecundaria != null) {
              if(idSucursalSecundaria != idSucursalActual){
                this.setSucursalSecundariaTipoDomicilio(idSucursalSecundaria, idUsuario, aplicaServicioDescargue, product, quantity);
              }else{
                this.modalConfirmation(product, quantity);
              }
            }
          });
        }
      });
    }
  }

  setSucursalSecundariaRecogeEntrega(idSucursal, userId, product, quantity) {

    let mensajeCambioSucursal = '';
    let mensajeCambioHorarioBodega = '';
    let allMessage = [];
    try {
      mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
      mensajeCambioHorarioBodega = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_HORARIO_BODEGA;
      allMessage.push(mensajeCambioSucursal);
      allMessage.push(mensajeCambioHorarioBodega);

    } catch (e) {
    }
    this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
      if (!response.error) {
        // Set the current client
        try {
          let newCurrentClient = JSON.parse(global.localStorage.currentClient);
          newCurrentClient.operatingCenter = response.branch;
          newCurrentClient.seller = response.seller;
          this.SessionService.put('currentClient', newCurrentClient);
          this.SessionService.put('cartId', response.cartID);
          this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
          this.shCtrl.userData.globals.currentClient.seller = response.seller;

          this.$rootScope.$broadcast('actualizarHeader', response.branch);
          this.SharedService.assignWarehouseBasketCode({ 'cartId': this.shCtrl.cart.cartId }).then(response => {
            if (!response.error) {
              if (allMessage !== null) {
                this.showModalAllMessage(allMessage, product, quantity);
              }
            }
          });
        } catch (e) {
        }
      } else {
        console.log('Ocurrio un erro al cambiar la sucursal')
      }
    }).catch(reason => {
      this.state.saving = false;
      this.state.error = true;
    });
  }

  setSucursalSecundariaTipoDomicilio(idSucursal, userId, aplicaServicioDescargue, product, quantity) {

    let mensajeCambioSucursal = '';
    let mensajeDestinoNoDisponilble = '';
    let mensajeCambioPromesa = '';
    let allMessage = [];

    try {
      mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
      mensajeCambioPromesa = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_PROMESA;
      allMessage.push(mensajeCambioSucursal);
      allMessage.push(mensajeCambioPromesa);

      if (!aplicaServicioDescargue) {
        mensajeDestinoNoDisponilble = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATITVO_DESTINOS_NO_DISPONIBLES;
        allMessage.push(mensajeDestinoNoDisponilble);
      }

    } catch (e) {
    }
    this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
      if (!response.error) {
        // Set the current client
        try {
          let newCurrentClient = JSON.parse(global.localStorage.currentClient);
          newCurrentClient.operatingCenter = response.branch;
          newCurrentClient.seller = response.seller;
          this.SessionService.put('currentClient', newCurrentClient);
          this.SessionService.put('cartId', response.cartID);
          this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
          this.shCtrl.userData.globals.currentClient.seller = response.seller;

          this.$rootScope.$broadcast('actualizarHeader', response.branch);
          this.SharedService.assignWarehouseBasketCode({ 'cartId': this.shCtrl.cart.cartId }).then(response => {
            if (!response.error) {
              if (allMessage !== null) {
                this.showModalAllMessage(allMessage, product, quantity);
              }
            }
          });
        } catch (e) {
        }
      } else {
        console.log('ocurrio un error al cambiar de sucursal')
      }
    }).catch(reason => {
      this.state.saving = false;
      this.state.error = true;
    });
  }

  cambiarSucursalVolumenItemMostrarMedioEnvio(response, product, quantity) {
    let responseData = response
    let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
    let idUsuario = this.shCtrl.globals.currentUser.userId;
    let currentClient  = this.SessionService.get('currentClient');
    let idSucursalActual = currentClient.operatingCenter.id;
    let data = {
      'userId': idUsuario,
      'ciudadId': idCiudad
    };
    this.CartService.getSecondaryBranch(data).then(response => {
      let idSucursalSecundaria = response.listaSucursales[0].id;
      if (idSucursalSecundaria != null) {
        if(idSucursalSecundaria != idSucursalActual){
          this.setSucursalSecundariaMostrarModalMedioEnvio(idSucursalSecundaria, idUsuario, responseData, product, quantity);
        }else{
          this.modalConfirmation(product, quantity);
        }
      }
    });


  }

  setSucursalSecundariaMostrarModalMedioEnvio(idSucursal, userId, mediosEnvio, product, quantity) {
    let mensajeCambioSucursal = '';
    try {
      mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
    } catch (e) {
    }
    this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
      if (!response.error) {
        // Set the current client
        try {
          let newCurrentClient = JSON.parse(global.localStorage.currentClient);
          newCurrentClient.operatingCenter = response.branch;
          newCurrentClient.seller = response.seller;
          this.SessionService.put('currentClient', newCurrentClient);
          this.SessionService.put('cartId', response.cartID);
          this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
          this.shCtrl.userData.globals.currentClient.seller = response.seller;
          this.$rootScope.$broadcast('actualizarHeader', response.branch);
          this.SharedService.assignWarehouseBasketCode({ 'cartId': this.shCtrl.cart.cartId}).then(response =>{
            if (!response.error) {
              if (mensajeCambioSucursal !== '') {
                let optionsMessage = {
                  title: 'Actualización de precios',
                  isHtml: true,
                  content: mensajeCambioSucursal,
                  size: '',
                  showBottonCancel: false,
                  textActionCancel: '',
                  textAction: 'Aceptar'
                };
                let modalInstance = this.$uibModal.open({
                  animation: true,
                  template: modalConfirmation,
                  controller: 'ModalResponseController',
                  controllerAs: 'mdCtrl',
                  backdrop: 'static',
                  size: 'md',
                  resolve: {
                    modalOptions: () => optionsMessage
                  }
                });
                modalInstance.result.then(() => {
                  this.showModalSelectModalidadPago(mediosEnvio, product, quantity);
                }).catch(() => {

                });
              }
            }
          });
        } catch (e) {
        }
      } else {
        alert('Ocurrion un error al mostrar los medios de envio')
      }
    }).catch(reason => {
      this.state.saving = false;
      this.state.error = true;
    });
  }

  showModalAllMessage(allMesagge, product, quantity) {
    let contentDynamic = 'Se realizaron las siguientes modificaciones: </br>';

    for (let i = 0; i < allMesagge.length; i++) {
      contentDynamic += `
                            <ul><li>` + allMesagge[i] + `</li></ul>`;
    }

    if (contentDynamic != '') {
      let optionsMessage = {
        title: 'Actualización de precios',
        isHtml: true,
        content: contentDynamic,
        size: '',
        showBottonCancel: false,
        textActionCancel: '',
        textAction: 'Aceptar',
        backdrop: 'static'
      };

      let modalInstance = this.$uibModal.open({
        animation: true,
        template: modalConfirmation,
        controller: 'ModalResponseController',
        controllerAs: 'mdCtrl',
        size: 'md',
        backdrop: 'static',
        resolve: {
          modalOptions: () => optionsMessage
        }
      });
      modalInstance.result.then(() => {
        this.modalConfirmation(product, quantity);
      }).catch(() => {

      });
    }
  }

  obtenerSucursalSecundaria(cartId, product, quantity) {
    let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
    let idUsuario = this.shCtrl.globals.currentUser.userId;
    let currentClient  = this.SessionService.get('currentClient');
    let idSucursalActual = currentClient.operatingCenter.id;
    let data = {
      'userId': idUsuario,
      'ciudadId': idCiudad
    };
    // Si la modalidad es recoge
    if (data != null) {
      this.CartService.getSecondaryBranch(data).then(response => {
        let idSucursalSecundaria = response.listaSucursales[0].id;
        if (idSucursalSecundaria != null) {
          if(idSucursalSecundaria != idSucursalActual){
            this.setSucursalSecundariaSinModalidad(idSucursalSecundaria, idUsuario, product, quantity);
          }else{
            this.modalConfirmation(product, quantity);
          }
        }
      });
      this.CartService.updateDateCart(cartId).then(response => {
        return response;
      });
    }
  }

  setSucursalSecundariaSinModalidad(idSucursal, userId, product, quantity) {

    let mensajeCambioSucursal = '';
    let allMessage = [];
    try {
      mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
      allMessage.push(mensajeCambioSucursal);
    } catch (e) {
    }
    this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
      if (!response.error) {
        // Set the current client
        try {
          let newCurrentClient = JSON.parse(global.localStorage.currentClient);
          newCurrentClient.operatingCenter = response.branch;
          newCurrentClient.seller = response.seller;
          this.SessionService.put('currentClient', newCurrentClient);
          this.SessionService.put('cartId', response.cartID);
          this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
          this.shCtrl.userData.globals.currentClient.seller = response.seller;

          this.$rootScope.$broadcast('actualizarHeader', response.branch);
          this.SharedService.assignWarehouseBasketCode({ 'cartId': this.shCtrl.cart.cartId }).then(response => {
            if (!response.error) {
              if (allMessage !== null) {
                this.showModalAllMessage(allMessage, product, quantity);
              }
            }
          });
        } catch (e) {
        }
      } else {
        console.log('Ocurrio un erro al cambiar la sucursal')
      }
    }).catch(reason => {
      this.state.saving = false;
      this.state.error = true;
    });
  }

}

BySearchController.$inject = inject;

export default BySearchController;



/** WEBPACK FOOTER **
 ** ./www/components/fast-purchase/by-search/by-search.controller.js
 **/